import { Button, InputGroup, Modal, ToggleButton } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../redux/hooks";
import { BuildThirdPartyListLink, ThirdPartyDispatch, BuildThirdPartyHeaders } from "./ThirdPartyFuncs";
import List, { ListName } from "../List/List";
import { ReactNode} from "react";
import { fetchData } from "../List/ListFuncs";
import { AppCodes } from "../navigationTypes";
import { buildDischargeLenderHeaders, buildDischargeLenderLink } from "../MortgageLender/DischargeLenderLink";
import { buildMortgageLenderHeaders, buildMortgageLenderLink } from "../MortgageLender/MortgageLenderLink";
import { lddStateObject } from "../../redux/reducer";
import "./LawyerList.css";

type ListDef = {
    Sublists?: {
        listName: ListName,   // listName for rwapi api
        label: string,
        fileListColumns: string[],
        searchTable: string,
        nodeName?: string,
        AppCode?: AppCodes[],
        defaultColumn?: string,
        buildHead?: (...arg: any[]) => JSX.Element,
        buildListLink?: (...arg: any[]) => ((T, index?: number) => JSX.Element),
        dataType?: "static" | "dynamic",
        sortingMethod?: "client" | "server",
    }[],
    reduxShowState: string,
}

export const ListDefine: Record<ListName, ListDef> = {
    "FileList": null,
    "LawyerList": {
        Sublists: [
            { listName: "AllLawyerList", label: "All Lawyers", fileListColumns: ['indexattributevalue', 'isNotary', 'FirmName', 'Address', 'LawyerID'], searchTable: 'AllSolicitor', nodeName: "Solicitor", defaultColumn: 'indexattributevalue', },
            { listName: "NotaryList", label: "Notary", fileListColumns: ['indexattributevalue', 'FirmName', 'Address'], searchTable: 'Notary', nodeName: "Solicitor", AppCode: ["RPWBC"], },
            { listName: "LawyerList", label: "Lawyer", fileListColumns: ['indexattributevalue', 'FirmName', 'Address'], searchTable: 'Solicitor', nodeName: "Solicitor", },
        ],
        reduxShowState: 'showLawyerList',
    },
    "InsuranceList": {
        Sublists: [
            { listName: "InsuranceList", label: "Insurance Agent List", fileListColumns: ['indexattributevalue'], searchTable: 'Insurance_Agent', nodeName: "InsuranceAgent", defaultColumn: 'indexattributevalue',},
        ],
        reduxShowState: 'showInsuranceList',
    },  
    "RealEstateBrokerList": {
        Sublists: [
            { listName: 'RealEstateBrokerList', label: 'Real Estate Broker List', fileListColumns: ['indexattributevalue', 'Name', 'Address'], searchTable: 'Real_estate_agent', nodeName: "RealEstateAgent", defaultColumn: 'Name',}
        ],
        reduxShowState: 'showRealEstateBrokerList',
    },
    "PurchaserRealEstateBrokerList": {
        Sublists: [
            { listName: 'PurchaserRealEstateBrokerList', label: 'Purchaser Real Estate Broker List', fileListColumns: ['indexattributevalue', 'Name', 'Address'], searchTable: 'Real_estate_agent', nodeName: "PurchaserRealEstateAgent", defaultColumn: 'Name',}
        ],
        reduxShowState: 'showPurchaserRealEstateBrokerList',
    },
    "ConveyancerList": {
        Sublists: [
            { listName: 'ConveyancerList', label: 'Conveyancer List', fileListColumns: ['indexattributevalue'], searchTable: 'conveyancer', nodeName: "Conveyancer", defaultColumn: 'indexattributevalue',}
        ],
        reduxShowState: 'showConveyancerList',
    },
    "MortgageBrokerList": {
        Sublists: [
            { listName: 'MortgageBrokerList', label: 'Mortgage Broker List', fileListColumns: ['indexattributevalue'], searchTable: 'mortgage_broker', nodeName: "MortgageBroker", defaultColumn: 'indexattributevalue',}
        ],
        reduxShowState: 'showMortgageBrokerList',
    },
    "MortgageLenderList": {
        Sublists: [
            { listName: "MortgageLenderList", label: "Lender", fileListColumns: ["Name", "LawyerID"], searchTable: 'lenders', nodeName: "Lender", buildHead: buildMortgageLenderHeaders, buildListLink: buildMortgageLenderLink, defaultColumn: 'Name', sortingMethod: "client" },
            // { listName: "AllMortgageLenderList", label: "All Lenders", fileListColumns: ["Name", "LawyerID"], searchTable: 'alllenders_misc', nodeName: "Lender", buildHead: buildMortgageLenderHeaders, buildListLink: buildMortgageLenderLink, defaultColumn: 'Name', },
            { listName: "DischargeLenderList", label: "Discharge Center", fileListColumns: ["Name"], searchTable: 'discharge_center', nodeName: "Lender", buildHead: buildDischargeLenderHeaders, buildListLink: buildDischargeLenderLink, defaultColumn: 'Branch', sortingMethod: "client" },
        ],
        reduxShowState: "showMortgageLenderList",
    },
    "MortgageLenderSelectFieldList": {
        Sublists: [
            { listName: "MortgageLenderList", label: "Lender", fileListColumns: ["Name"], searchTable: 'lenders', nodeName: "Lender", buildHead: buildMortgageLenderHeaders, buildListLink: null, },
        ],
        reduxShowState: "showMortgageLenderSelectFieldList",
    },
    "NotaryList": null,
    "AllMortgageLenderList": null,
    "DischargeLenderList": null,
    "OtherPartyList": {
        Sublists: [
            { listName: 'OtherPartyList', label: 'Third Party List', fileListColumns: ['indexattributevalue', 'Name', 'Address'], searchTable: 'other_party', nodeName: "OtherParty", defaultColumn: 'indexattributevalue', }
        ],
        reduxShowState: 'showOtherPartyList',
    },
    "AllLawyerList": null,
    "SelectFileList": {
        reduxShowState: 'showSelectFileList',
    },
    "MortgageBranchList": null, 
    "SuggestedList": null,
    "DRFileList": {
        reduxShowState: 'showDRFileList',
        Sublists: [
            { listName: 'DRFileList',
                label: 'Document Retrieval List',
                fileListColumns: ['From', 'Type', 'Received', 'Lawyer', 'Client', 'Address', 'Closing Date'],
                searchTable: 'other_party',
                nodeName: "OtherParty",
                buildHead: buildMortgageLenderHeaders,
                buildListLink: null,
                dataType: "static",
            }
        ],
    },
    "TaskList": {
        reduxShowState: 'showTaskList',
        Sublists: [
            {
                listName: 'TaskList',
                label: 'Task Management List',
                fileListColumns: ['Task Description', 'Due', 'Key Date', 'PSM', 'Assigned Users', 'Activate in File'],
                searchTable: 'profile',
                dataType: "static"
            }
        ]
    }
}

export const ThirdPartyList = (props: { listName: ListName }) => {
    const showList = useAppSelector((state) => state.ThirdPartyListState === ListDefine[props.listName].reduxShowState);
    const APPCODE: AppCodes = useAppSelector((g) => g.SessionInfo?.appCode);
    const skipSetThirdPartyData = useAppSelector((state: lddStateObject) => state.SkipSetThirdPartyData);
    const solicitorTargetNode = useAppSelector((state: lddStateObject) => state.ThirdPartyListExtraPayload?.solicitorTargetNode || "Solicitor");
    const dispatch = useDispatch();
    const listDef = ListDefine[props.listName].Sublists.filter(list => !list.AppCode || list.AppCode.indexOf(APPCODE) !== -1);

    const buildQpickListLinkWrapper = (columns: string[], dataroot: Element, tableType: string, navObj?: any, navigateContext?: any, province?: any, searchString?: string, dispatch?: React.Dispatch<any>, otherListExtraPayload?: any) => {
        return BuildThirdPartyListLink(columns, dataroot, tableType, navObj, navigateContext, province, searchString, dispatch, skipSetThirdPartyData);
    };

    const LawyerListHead = (props : {
        filterFunc: (filter: string[]) => void, 
        children: ReactNode[], 
        filterState: string[], 
        setFilterState: (filter: string[]) => void
    }) => {
        const buttons = APPCODE == 'RPWBC' ? ['System', 'User', 'Lawyer', 'Notary'] : ['System', 'User'];

        const handleFilter = (index: number) => {
            let tempState = props.filterState.map((data) => data);
            tempState[index] = tempState[index] == '' ? buttons[index] : '';
            props.filterFunc(tempState);
        };

        return (<>
            <>
                {APPCODE == 'RPWBC' ? <h2>Legal Representatives</h2> : <h2>Lawyers</h2>}
                <InputGroup id="searchInputCol" className="search-bar">
                    {props.children[0]}
                    {props.children[1]}
                    <div className="buttons-container">
                        {props.children[2]}
                        {buttons.map((value, index) =>
                            <>                        
                                <ToggleButton
                                    type="checkbox" 
                                    onClick={() => handleFilter(index)} 
                                    checked={props.filterState[index] != ''}
                                    value={value} key={index}>
                                    {value}
                                </ToggleButton>
                                {buttons.length > 2 && index == 1 && <span>|</span>}
                            </>
                        )}
                    </div>
                </InputGroup>
            </>
        </>)
    }
    var list = listDef[0]; //the initial all lawyer list
    return (
        (showList ?
            <Modal centered show={true} size="xl" className="modal-list">
                <>
                    <List
                        as={"ModalBody"}
                        listName={list.listName}
                        handleLoadQpickData={fetchData}
                        headBar={(props.listName === 'AllLawyerList' || props.listName === 'LawyerList') ? LawyerListHead : null}
                        ListColumns={list.fileListColumns}
                        buildHead={(columns, handleClick, province, getSortIcon) => 
                            BuildThirdPartyHeaders(columns, handleClick, province, getSortIcon)
                        }
                        buildQpickListLink={buildQpickListLinkWrapper}
                        searchTable={list.searchTable}
                        defaultColumn={list.defaultColumn}
                        nodeName={props.listName === "LawyerList" ? solicitorTargetNode : list.nodeName}
                        sortingMethod={list.sortingMethod}
                        listContainerID={`${list.listName}-container`} 
                    />
                </>

                <Modal.Footer>
                    <Button className="cancel-button" variant="outline-primary" onClick={async () => {
                        ThirdPartyDispatch(dispatch, props.listName, false);
                    }}
                    >Cancel</Button>
                </Modal.Footer>
            </Modal>
            :
            null)
    )
}